// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Ftiles.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------

import { IBinary, IBlob, IBlobRef, IContextHolder, IDocument, IDynamicContext, IEventsHolder, IGridCell, IGridNeighborhoodContext, ISession, ISubDocument, ITenantContextHolder, ITileGroup, IUserCommandsHolder, IUserContextHolder, OpenType } from '../tiles';
import { SchemaObject } from './schema-object.g';
import { ISchemaObject, SchemaObjectHeader } from '../schema-object';

export class Blob implements IBlob {
    public readonly id: string;
    public readonly sizeBytes: number;
    public readonly data?: Uint8Array;
    public readonly dataPointer?: IBlobRef;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IBlob) {
        SchemaObject.assign(Blob, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_Blob';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: Blob.getTypeName(), B_: Blob.getBaseTypes() };
    /**
     * Checks if passed schema object is of Blob type or its inheritor and implements {@link IBlob}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IBlob {
        return SchemaObject.matchesTypesFor(schemaObject, [Blob.getTypeName()]);
    }
}

export class Binary implements IBinary {
    public data?: Uint8Array;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IBinary) {
        SchemaObject.assign(Binary, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_Binary';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: Binary.getTypeName(), B_: Binary.getBaseTypes() };
    /**
     * Checks if passed schema object is of Binary type or its inheritor and implements {@link IBinary}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IBinary {
        return SchemaObject.matchesTypesFor(schemaObject, [Binary.getTypeName()]);
    }
}

export class TileGroup implements ITileGroup {
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ITileGroup) {
        SchemaObject.assign(TileGroup, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_TileGroup';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: TileGroup.getTypeName(), B_: TileGroup.getBaseTypes() };
    /**
     * Checks if passed schema object is of TileGroup type or its inheritor and implements {@link ITileGroup}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ITileGroup {
        return SchemaObject.matchesTypesFor(schemaObject, [TileGroup.getTypeName()]);
    }
}

export class Session implements ISession {
    public readonly activeUserId: string;
    public readonly widthDpi?: number;
    public readonly heightDpi?: number;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISession) {
        SchemaObject.assign(Session, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_Session';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_TileGroup'];
    }
    public static readonly H_ = { T_: Session.getTypeName(), B_: Session.getBaseTypes() };
    /**
     * Checks if passed schema object is of Session type or its inheritor and implements {@link ISession}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ISession {
        return SchemaObject.matchesTypesFor(schemaObject, [Session.getTypeName()]);
    }
}

export class Document implements IDocument {
    public readonly isReadonly: boolean;
    public readonly title?: string;
    public readonly url?: string;
    public readonly openType?: OpenType;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IDocument) {
        SchemaObject.assign(Document, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_Document';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_TileGroup'];
    }
    public static readonly H_ = { T_: Document.getTypeName(), B_: Document.getBaseTypes() };
    /**
     * Checks if passed schema object is of Document type or its inheritor and implements {@link IDocument}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IDocument {
        return SchemaObject.matchesTypesFor(schemaObject, [Document.getTypeName()]);
    }
}

export class SubDocument implements ISubDocument {
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISubDocument) {
        SchemaObject.assign(SubDocument, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_SubDocument';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: SubDocument.getTypeName(), B_: SubDocument.getBaseTypes() };
    /**
     * Checks if passed schema object is of SubDocument type or its inheritor and implements {@link ISubDocument}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ISubDocument {
        return SchemaObject.matchesTypesFor(schemaObject, [SubDocument.getTypeName()]);
    }
}

export class GridCell implements IGridCell {
    public readonly column: number;
    public readonly row: number;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IGridCell) {
        SchemaObject.assign(GridCell, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_GridCell';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: GridCell.getTypeName(), B_: GridCell.getBaseTypes() };
    /**
     * Checks if passed schema object is of GridCell type or its inheritor and implements {@link IGridCell}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IGridCell {
        return SchemaObject.matchesTypesFor(schemaObject, [GridCell.getTypeName()]);
    }
}

export class GridNeighborhoodContext implements IGridNeighborhoodContext {
    public readonly width: number;
    public readonly height: number;
    public readonly retrievedWidth: number;
    public readonly retrievedHeight: number;
    public readonly neighborhoodTopRow: number;
    public readonly neighborhoodLeftColumn: number;
    public readonly targetGridTopRow: number;
    public readonly targetGridLeftColumn: number;
    public readonly targetGridRelativeTopRow: number;
    public readonly targetGridRelativeLeftColumn: number;
    public readonly numberOfNonEmptyCells: number;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IGridNeighborhoodContext) {
        SchemaObject.assign(GridNeighborhoodContext, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_GridNeighborhoodContext';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: GridNeighborhoodContext.getTypeName(), B_: GridNeighborhoodContext.getBaseTypes() };
    /**
     * Checks if passed schema object is of GridNeighborhoodContext type or its inheritor and implements {@link IGridNeighborhoodContext}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IGridNeighborhoodContext {
        return SchemaObject.matchesTypesFor(schemaObject, [GridNeighborhoodContext.getTypeName()]);
    }
}

export class DynamicContext implements IDynamicContext {
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IDynamicContext) {
        SchemaObject.assign(DynamicContext, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_DynamicContext';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: DynamicContext.getTypeName(), B_: DynamicContext.getBaseTypes() };
    /**
     * Checks if passed schema object is of DynamicContext type or its inheritor and implements {@link IDynamicContext}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IDynamicContext {
        return SchemaObject.matchesTypesFor(schemaObject, [DynamicContext.getTypeName()]);
    }
}

export class ContextHolder implements IContextHolder {
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IContextHolder) {
        SchemaObject.assign(ContextHolder, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_ContextHolder';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: ContextHolder.getTypeName(), B_: ContextHolder.getBaseTypes() };
    /**
     * Checks if passed schema object is of ContextHolder type or its inheritor and implements {@link IContextHolder}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IContextHolder {
        return SchemaObject.matchesTypesFor(schemaObject, [ContextHolder.getTypeName()]);
    }
}

export class UserContextHolder implements IUserContextHolder {
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IUserContextHolder) {
        SchemaObject.assign(UserContextHolder, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_UserContextHolder';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_ContextHolder'];
    }
    public static readonly H_ = { T_: UserContextHolder.getTypeName(), B_: UserContextHolder.getBaseTypes() };
    /**
     * Checks if passed schema object is of UserContextHolder type or its inheritor and implements {@link IUserContextHolder}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IUserContextHolder {
        return SchemaObject.matchesTypesFor(schemaObject, [UserContextHolder.getTypeName()]);
    }
}

export class TenantContextHolder implements ITenantContextHolder {
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ITenantContextHolder) {
        SchemaObject.assign(TenantContextHolder, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_TenantContextHolder';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_ContextHolder'];
    }
    public static readonly H_ = { T_: TenantContextHolder.getTypeName(), B_: TenantContextHolder.getBaseTypes() };
    /**
     * Checks if passed schema object is of TenantContextHolder type or its inheritor and implements {@link ITenantContextHolder}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ITenantContextHolder {
        return SchemaObject.matchesTypesFor(schemaObject, [TenantContextHolder.getTypeName()]);
    }
}

export class EventsHolder implements IEventsHolder {
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IEventsHolder) {
        SchemaObject.assign(EventsHolder, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_EventsHolder';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: EventsHolder.getTypeName(), B_: EventsHolder.getBaseTypes() };
    /**
     * Checks if passed schema object is of EventsHolder type or its inheritor and implements {@link IEventsHolder}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IEventsHolder {
        return SchemaObject.matchesTypesFor(schemaObject, [EventsHolder.getTypeName()]);
    }
}

export class UserCommandsHolder implements IUserCommandsHolder {
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IUserCommandsHolder) {
        SchemaObject.assign(UserCommandsHolder, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_UserCommandsHolder';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_EventsHolder'];
    }
    public static readonly H_ = { T_: UserCommandsHolder.getTypeName(), B_: UserCommandsHolder.getBaseTypes() };
    /**
     * Checks if passed schema object is of UserCommandsHolder type or its inheritor and implements {@link IUserCommandsHolder}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IUserCommandsHolder {
        return SchemaObject.matchesTypesFor(schemaObject, [UserCommandsHolder.getTypeName()]);
    }
}

